import Alpine from "alpinejs";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

window.Alpine = Alpine;

Alpine.start();

const swiperRecentPosts = new Swiper(".swiper-recent-posts", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
  },
});

const swiperHero = new Swiper(".swiper-hero", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
